<a mat-list-item (click)="toggle()">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Ações Gerenciais">
            <mat-icon>local_library</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Ações Gerenciais</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>
<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">        

        <!-- REUNIÕES -->
        <sub-menu *ngIf="verificaAcesso(getModulos().REUNIOES_ACOES_GERENCIAIS)" icone="event" titulo="Reuniões Gerenciais"
            rota="reunioes" toolTip="Reuniões Gerenciais"></sub-menu>

        <!-- OFICINA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().ATIVIDADES_ACOES_GERENCIAIS)" icone="pages" titulo="Atividades Gerenciais" 
            rota="oficinas" toolTip="Atividades Gerenciais"></sub-menu>

        <!-- MATRICULA NA OFICINA -->
        <sub-menu *ngIf="verificaAcesso(getModulos().MATRICULA_ATIVIDADE_ACOES_GERENCIAIS)" icone="sports_handball" titulo="Matrícula na Atividade"
        rota="atividadealuno" toolTip="Matrícula na Atividade"></sub-menu>

        <!-- TABELAS REFERENCIA -->
        <tb-referencia-gerencial></tb-referencia-gerencial>
    </div>
</mat-nav-list>